import React from 'react'
import { Box, Typography } from '@material-ui/core'

type SectionContents = {
  description: string
  title: string
}

const OnboardingSectionTitle = ({ title, description }: SectionContents) => {
  return (
    <Box p={0} mb={3}>
      <Typography variant="h6">{title}</Typography>
      <Typography variant="body2">{description}</Typography>
    </Box>
  )
}

export default OnboardingSectionTitle
